import {Observable} from 'rxjs/Observable';
import {catchError, map, startWith} from 'rxjs/operators';
import {ObservableInput} from 'rxjs/src/Observable';
import {NetworkEntity} from '../types/data.types';

export function debounce(callback, wait, context = this) {
    let timeout = null;
    let callbackArgs = null;

    const later = () => callback.apply(context, callbackArgs);

    return function () {
        callbackArgs = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

export function throttle(callback, wait, context = this) {
    let timeout = null;
    let callbackArgs = null;

    const later = () => {
        callback.apply(context, callbackArgs);
        timeout = null;
    };

    return function () {
        if (!timeout) {
            callbackArgs = arguments;
            timeout = setTimeout(later, wait);
        }
    };
}

export function createInitialNetworkEntity<T = any>() {
    return (source: Observable<any>): Observable<NetworkEntity<T>> => {
        return source
            .pipe(
                startWith({
                    entities: [],
                    total: undefined,
                    finished: false,
                    loading: true
                })
            );
    };
}

export function resolveNetworkEntity<T = any, R = any>(
    dataAdapter?: (sourceData: T, index: number) => R,
    additionalPropertiesGenerator?: (sourceNetworkEntity?: Partial<NetworkEntity<T | R>>) => Record<any, any>
) {
    return (source: Observable<NetworkEntity<T>>): Observable<NetworkEntity<T | R>> => {
        return source
            .pipe(
                map(
                    response => {
                        if (response) {
                            const entities = typeof dataAdapter === 'function' ? response.entities.map(dataAdapter) as R[] : response.entities as T[];
                            return {
                                entities,
                                total: response.total,
                                finished: response.total !== undefined,
                                loading: response.total === undefined,
                                ...(additionalPropertiesGenerator ? additionalPropertiesGenerator({entities, total: response.total}) : {})
                            };
                        }
                        throw new Error('no content');
                    }
                )
            );
    };
}



// WEBPACK FOOTER //
// /app/src/app/services/helper-functions.ts